import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import KwHpConverter from '../components/tools/KwHpConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'kW to HP Calculator | Power Unit Converter | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert power instantly between Watts, Kilowatts, and mechanical Horsepower. Free online kW to HP calculator with formulas and adjustable precision.';

const KwHpConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="kw-hp-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="kW ↔ HP Calculator"
        description="Convert power between Watts, Kilowatts, and mechanical Horsepower. Enter a value in any unit and the other two update in real time."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="kw-hp-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <KwHpConverter />
          <ToolGuideCta guidePath="/tools/kw-hp-calculator/guide" toolName="kW ↔ HP Calculator" />
        </div>
      </section>
    </div>
  );
};

export default KwHpConverterPage;
